import { sample } from 'effector'
import { ZodError } from 'zod'

import { apiRequestError } from '../../../api'
import {
  ApiError,
  AuthError,
  NetworkError,
  NotFoundError,
} from '../../types/errors'
import { showNotificationErrorFx } from './notifications-provider.model'

sample({
  clock: apiRequestError,
  filter: (error) => !(error instanceof NotFoundError),
  fn: (error) => {
    let description = 'Что-то пошло не так'
    if (error instanceof AuthError) {
      description = 'Время сессии истекло'
    } else if (error instanceof ZodError) {
      description = 'Ошибка данных'
    } else if (error instanceof ApiError) {
      description = error.message
    } else if (error instanceof NetworkError) {
      description = error.message
    }
    return {
      description: description,
    }
  },
  target: showNotificationErrorFx,
})
